export const hu = {
  common: {
    loading: 'Betöltés...',
    cancel: 'Mégse',
    save: 'Mentés',
    close: 'Bezárás',
    submit: 'Küldés',
    error: 'Hiba történt',
    success: 'Siker',
    confirm: 'Megerősítés',
    actions: 'Műveletek',
    notes: 'Megjegyzések',
    unknown: 'Ismeretlen',
    na: 'N/A',
    viewDetails: 'Részletek megtekintése',
    accessDenied: 'Hozzáférés megtagadva',
    adminRequired: 'Adminisztrátori jogosultság szükséges.',
    delete: 'Törlés',
    edit: 'Szerkesztés',
    request: 'Igénylés',
    status: 'Státusz',
    user: 'Felhasználó',
    quantity: 'Mennyiség',
    date: 'Dátum',
    reason: 'Ok',
    role: 'Szerepkör',
    item: 'Eszköz',
    name: 'Név',
    location: 'Helyszín',
    tags: 'Címkék',
    description: 'Leírás',
    category: 'Kategória',
    categoryPlaceholder: 'Válasszon kategóriát...',
    locationPlaceholder: 'Válasszon helyszínt...',
    groupId: 'Csoport azonosító / Termék SKU (opcionális)',
    groupIdHelp: 'Használja ugyanazt az azonosítót a különböző helyszíneken lévő azonos eszközökhöz a csoportosításhoz.',
    imageUrl: 'Kép URL (opcionális)',
    created: 'Létrehozva',
    email: 'Email',
    itemName: 'Eszköz neve',
    expectedReturnDate: 'Várható visszahozatal',
    notesOptional: 'Megjegyzések (opcionális)',
    roles: {
      admin: 'Adminisztrátor',
      keeper: 'Kezelő',
      user: 'Felhasználó',
    },
    statuses: {
      pending: 'Függőben',
      approved: 'Jóváhagyva',
      rejected: 'Elutasítva',
      returned: 'Visszahozva',
      available: 'Elérhető',
      on_loan: 'Kölcsönben',
      low_stock: 'Alacsony készlet',
      out_of_stock: 'Készlethiány',
      maintenance: 'Karbantartás alatt',
      retired: 'Selejtezve',
    }
  },
  auth: {
    signIn: 'Bejelentkezés Google-fiókkal',
    signingIn: 'Bejelentkezés...',
    signOut: 'Kijelentkezés',
    failedSignIn: 'A bejelentkezés sikertelen. Kérjük, próbálja újra.',
    failedSignOut: 'A kijelentkezés sikertelen. Kérjük, próbálja újra.',
    loginError: 'Bejelentkezési hiba',
    troubleshooting: 'Hibaelhárítási útmutató megtekintése',
    roleRequestSubmitted: 'A szerepkör-kérelem sikeresen elküldve! Egy adminisztrátor hamarosan felülvizsgálja.',
    roleRequestFailed: 'A kérelem elküldése sikertelen. Kérjük, próbálja újra.',
    popupClosed: 'A bejelentkezés megszakítva. Kérjük, próbálja újra.',
    popupBlocked: 'Az előugró ablak blokkolva. Kérjük, engedélyezze az előugró ablakokat ezen az oldalon.',
    domainUnauthorized: 'A domain nincs engedélyezve. Kérjük, ellenőrizze a Firebase beállításokat.',
    invalidApiKey: 'Érvénytelen Firebase API kulcs. Kérjük, ellenőrizze a .env fájlt.',
    firestoreError: 'A hitelesítés sikeres, de az adatbázis kapcsolat sikertelen. Kérjük, ellenőrizze a Firestore konfigurációt.',
    timeout: 'Hitelesítési időtúllépés - Lehet, hogy a Firestore nincs konfigurálva',
    requestRoleChange: 'Szerepkör módosításának kérése',
    selectRoleDescription: 'Válassz egy szerepkört a hozzáférés igényléséhez.',
    selectRolePlaceholder: 'Válassz szerepkört...',
    roleHistory: 'Szerepkör előzmények',
    language: 'Nyelv',
    selectLanguage: 'Válasszon nyelvet',
    languages: {
      en: 'Angol',
      hu: 'Magyar',
    },
  },
  nav: {
    dashboard: 'Irányítópult',
    admin: 'Adminisztráció',
    myLoans: 'Kölcsönzéseim',
    settings: 'Beállítások',
    profile: 'Profil',
  },
  dashboard: {
    title: 'Leltár Irányítópult',
    addItem: 'Új eszköz',
    searchPlaceholder: 'Keresés név, leírás vagy címkék alapján...',
    allStatus: 'Minden státusz',
    allLocations: 'Minden helyszín',
    groupProducts: 'Termékek csoportosítása',
    noItems: 'Nincs megjeleníthető eszköz',
    available: 'Elérhető',
    onLoan: 'Kölcsönben',
    maintenance: 'Karbantartás alatt',
    retired: 'Selejtezve',
    requestItem: 'Eszköz igénylése',
    expectedReturnDate: 'Várható visszhozatal dátuma',
    itemLoanHistory: 'Eszköz kölcsönzési előzményei',
    productDetails: 'Termék részletei',
    inventoryBreakdown: 'Készlet részletezése',
    activeLoansSummary: 'Aktív kölcsönzések összefoglalója',
    total: 'Összesen',
    grouped: 'Csoportosítva',
    deleteConfirm: 'Biztosan törölni szeretné ezt az eszközt?',
    itemDeleted: 'Az eszköz sikeresen törölve',
    itemSaved: 'Az eszköz sikeresen mentve',
    requestSubmitted: 'Az igénylés sikeresen elküldve!',
    loginRequired: 'Az igényléshez be kell jelentkeznie',
    selectDate: 'Kérjük, válasszon visszhozatali dátumot',
    invalidDate: 'Érvénytelen dátum',
    futureDate: 'A dátumnak a jövőben kell lennie',
    requested: 'Igényelve',
    returned: 'Visszahozva',
    lowStock: 'Alacsony készlet',
    outOfStock: 'Készlethiány',
  },
  admin: {
    title: 'Adminisztrációs Panel',
    pendingRequests: 'Függőben lévő kérelmek',
    activeLoans: 'Aktív kölcsönzések',
    returnedLoans: 'Visszavett eszközök',
    roleRequests: 'Szerepkör kérelmek',
    userManagement: 'Felhasználó kezelés',
    noPending: 'Jelenleg nincs függőben lévő kérelem.',
    noActive: 'Jelenleg nincs aktív kölcsönzés.',
    noReturned: 'Még nincs visszavett eszköz.',
    noRoleRequests: 'Nincs függőben lévő szerepkör kérelem.',
    approve: 'Jóváhagyás',
    reject: 'Elutasítás',
    markReturned: 'Visszavétel',
    daysOut: 'napja kint',
    overdue: 'LEJÁRT',
    wasOverdue: 'Késve visszhozva',
    rejectLoan: 'Kölcsönzés elutasítása',
    rejectReason: 'Elutasítás oka (opcionális)',
    confirmReject: 'Elutasítás megerősítése',
    rejectWarning: 'Ez a művelet nem vonható vissza. A felhasználó értesítést kap az elutasításról.',
    loanApproved: 'A kölcsönzési kérelem jóváhagyva!',
    loanRejected: 'A kölcsönzési kérelem elutasítva.',
    itemReturned: 'Az eszköz visszavétele megtörtént!',
    roleApproved: 'Szerepkör kérelem jóváhagyva!',
    roleRejected: 'Szerepkör kérelem elutasítva.',
    confirmRoleChange: 'Biztosan megváltoztatja a felhasználó szerepkörét erre:',
    roleUpdated: 'Felhasználói szerepkör frissítve:',
    requestedBy: 'Igénylő',
    requestedDate: 'Igénylés dátuma',
    borrowedBy: 'Kölcsönző',
    approvedDate: 'Jóváhagyás dátuma',
    duration: 'Időtartam',
    currentRole: 'Jelenlegi szerepkör',
    requestedRole: 'Igényelt szerepkör',
    changeRole: 'Szerepkör módosítása',
  },
  myLoans: {
    title: 'Kölcsönzéseim',
    subtitle: 'Kölcsönzött eszközeid és igényléseid nyomon követése',
    currentLoans: 'Jelenlegi kölcsönzések',
    loanHistory: 'Kölcsönzési előzmények',
    noCurrent: 'Jelenleg nincs aktív kölcsönzésed.',
    noHistory: 'Nincs korábbi kölcsönzésed.',
    awaitingApproval: 'Jóváhagyásra vár',
    currentlyBorrowed: 'Jelenleg nálad van',
    completedLoans: 'Befejezett kölcsönzések',
    status: {
      pending: 'Függőben',
      approved: 'Jóváhagyva',
      rejected: 'Elutasítva',
      returned: 'Visszavéve',
    }
  },
  settings: {
    title: 'Beállítások',
    locations: 'Helyszínek',
    categories: 'Kategóriák',
    addLocation: 'Helyszín hozzáadása',
    addCategory: 'Kategória hozzáadása',
    locationName: 'Helyszín neve',
    categoryName: 'Kategória neve',
    deleteConfirm: 'Biztosan törölni szeretné?',
    saved: 'Sikeresen mentve',
    deleted: 'Sikeresen törölve',
    manageLocations: 'Helyszínek kezelése',
    manageCategories: 'Kategóriák kezelése',
    active: 'Aktív',
    inactive: 'Inaktív',
    locationDescription: 'Helyszín leírása (opcionális)',
    categoryDescription: 'Kategória leírása (opcionális)',
  }
};
